import { makeStyles } from '@material-ui/core';
import React from 'react';
import { NavLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '185px', 
    textAlign: 'center',
    backgroundColor: 'black',
    display: 'flex',
    justifyContent: 'center', 
    alignItems: 'center', 
  },
  navLink: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    margin: "0 1rem",
  },
}));

function Footer() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div style={{ padding: "20px 0" }}>
        <NavLink to="/privacy-policy" className={classes.navLink}>
          Privacy Policy
        </NavLink>
        <NavLink to="/terms" className={classes.navLink}>
          Terms Of Use
        </NavLink>
      </div>
    </div>
  );
}

export default Footer;
